import {DatePicker, DatePickerProps} from '@mui/x-date-pickers';
import dayjs, {Dayjs} from 'dayjs';
import React from 'react';

export interface DefaultDatePickerProps extends DatePickerProps {
    value: Dayjs | null | undefined;
    catchValue?: (value: Dayjs | undefined) => void;
}

export function DefaultDatePicker(props:DefaultDatePickerProps)  {
    const omittedProps: Omit<DatePickerProps, 'value' | 'onChange'> = props;


    return (
        <DatePicker value={props.value ?? undefined} onChange={(e, v) => {
            if (!props.catchValue) {
                if (props.onChange) {
                    // If onChange is provided, call it with the event and value
                    return props.onChange(e, v);
                }
                return;
            }
            props.catchValue(dayjs(e));
        }}
                    slotProps={{
                        actionBar: {actions: ['clear', 'today']},
                        textField: {fullWidth: true},
                    }}
                    {...omittedProps}
        />
    );
}